import React from "react";
import Popup from "reactjs-popup";
import { SubtitleContext } from "../../contexts/SubtitleContext";
import ZeroTimeMainView from "../layout/ZeroTime/ZeroTimeMainView";
import TimeUtils from "../../helper/TimeUtils";
import TimecodeShiftMainView from "../layout/TimecodeShift/TimecodeShiftMainView";

const TimecodeShiftView_Popup = ({ _WaveformView }) => {
  return (
    <Popup
      open={_WaveformView.state.isShowTimecodeShiftView}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowTimecodeShiftView: false });
      }}
      contentStyle={{ width: "800px" }}
    >
      <SubtitleContext.Consumer>
        {(context) => (
          <TimecodeShiftMainView
            closeTranslationsNavbarAlertView={() => {
              _WaveformView.setState({ isShowTimecodeShiftView: false });
            }}
            onClose={() => {
              _WaveformView.setState({ isShowTimecodeShiftView: false });
            }}
            context={context}
            projectDetial={_WaveformView.projectDetial}
            //執行
            applyshift={async (
              selectIndex,
              firstDataIndex,
              lastDataIndex,
              orgTimeString,
              newTitleString,
              Sign
            ) => {
              let distance;
              if (selectIndex === 0) {
                // 
                let newFrameNumber =
                  TimeUtils.timeString_convertTo_frame(newTitleString);
                let oldFrameNumber =
                  TimeUtils.timeString_convertTo_frame(orgTimeString);
                distance =
                  parseFloat(newFrameNumber) - parseFloat(oldFrameNumber);
              } else {
                //使用中間的秒數差
                let newFrameNumber =
                  TimeUtils.timeString_convertTo_frame(newTitleString);

                distance = newFrameNumber;
                if (Sign === "-") {
                  distance = distance * -1;
                }
              }

              /** 把所有的開始跟結束時間都加上距離 */
              _WaveformView.activeTimecodeshift(
                TimeUtils.getFPS(),
                _WaveformView.findFrameSplitValue,
                distance,
                firstDataIndex,
                lastDataIndex
              );

              /** 更新 orgTimeString */
              //關閉
              _WaveformView.setState({
                isShowTimecodeShiftView: false,
                isShowTranslationsNavbarAlert: false,
              });
            }}
          />
        )}
      </SubtitleContext.Consumer>
    </Popup>
  );
};

export default TimecodeShiftView_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/TimecodeShiftView_Popup.js